"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = require("../component");

var _styles = require("../styles");

var _utils = _interopRequireDefault(require("./utils"));

var _Year = _interopRequireDefault(require("./Year"));

var _Month = _interopRequireDefault(require("./Month"));

var _Day = _interopRequireDefault(require("./Day"));

var _Time = _interopRequireDefault(require("./Time"));

var _Quick = _interopRequireDefault(require("./Quick"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Picker =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Picker, _PureComponent);

  function Picker(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    var mode;

    switch (props.type) {
      case 'month':
        mode = 'month';
        break;

      case 'time':
        mode = 'time';
        break;

      default:
        mode = 'day';
    }

    _this.state = {
      mode: mode
    };
    _this.defaultCurrent = new Date(_utils.default.formatDateWithDefaultTime(_utils.default.newDate(), undefined, props.defaultTime[0], 'yyyy-MM-dd HH:mm:ss'));
    _this.handleModeChange = _this.handleModeChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleEnter = _this.handleMouse.bind(_assertThisInitialized(_assertThisInitialized(_this)), true);
    _this.handleLeave = _this.handleMouse.bind(_assertThisInitialized(_assertThisInitialized(_this)), false);
    _this.handleQuick = _this.handleQuick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Picker.prototype;

  _proto.handleQuick = function handleQuick(quick) {
    var onChange = this.props.onChange;
    onChange.apply(void 0, _utils.default.quickHandleChangeParams(quick.value[0], true, null, null, quick));
  };

  _proto.handleMouse = function handleMouse(isEnter, e) {
    // stop
    e.stopPropagation();
    var _this$props = this.props,
        index = _this$props.index,
        handleHover = _this$props.handleHover;
    handleHover(index, isEnter);
  };

  _proto.handleModeChange = function handleModeChange(mode) {
    var _this2 = this;

    setTimeout(function () {
      _this2.setState({
        mode: mode
      });
    }, 10);
  };

  _proto.render = function render() {
    var mode = this.state.mode;

    var _this$props2 = this.props,
        current = _this$props2.current,
        index = _this$props2.index,
        children = _this$props2.children,
        otherProps = _objectWithoutPropertiesLoose(_this$props2, ["current", "index", "children"]);

    var Render;

    switch (mode) {
      case 'year':
        Render = _Year.default;
        break;

      case 'month':
        Render = _Month.default;
        break;

      case 'time':
        Render = _Time.default;
        break;

      default:
        Render = _Day.default;
    } // only range has index prop


    if (index === undefined) return _react.default.createElement("div", {
      className: (0, _styles.datepickerClass)('split')
    }, _react.default.createElement(_Quick.default, _extends({}, otherProps, {
      current: current || this.defaultCurrent,
      onChange: this.handleQuick
    })), _react.default.createElement(Render, _extends({}, otherProps, {
      current: current || this.defaultCurrent,
      onModeChange: this.handleModeChange
    })));
    return _react.default.createElement("div", {
      onMouseEnter: this.handleEnter,
      onMouseLeave: this.handleLeave
    }, _react.default.createElement(Render, _extends({}, otherProps, {
      index: index,
      current: current || this.defaultCurrent,
      onModeChange: this.handleModeChange
    })));
  };

  return Picker;
}(_component.PureComponent);

Picker.propTypes = {
  current: _propTypes.default.object,
  disabled: _propTypes.default.func,
  format: _propTypes.default.string,
  max: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  min: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  onChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.object,
  type: _propTypes.default.string.isRequired,
  index: _propTypes.default.number,
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  handleHover: _propTypes.default.func,
  defaultTime: _propTypes.default.array
};
var _default = Picker;
exports.default = _default;